<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Driver Absence was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit Driver Bonus Level - {{ this.driverBonusLevel.name }}</h1>
    <app-audit-line [data]='this.driverBonusLevel'></app-audit-line>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-driver-bonus-level-form [bonusLevel]='this.driverBonusLevel'></app-driver-bonus-level-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/drivers/bonus'>Cancel</button>
    </form>
  </div>
</div>
